import { useCallback, useLayoutEffect, useRef, useState } from 'react';
import BaseTooltip from '@/global/Tooltip/BaseTooltip';

export function BottomDetailValueWithTooltip({ text }: { text: string }) {
  const lineRef = useRef<HTMLDivElement>(null);
  const [isOverflowing, setIsOverflowing] = useState(false);

  const updateOverflow = useCallback(() => {
    const el = lineRef.current;
    if (!el) return;
    setIsOverflowing(el.scrollWidth > el.clientWidth + 0.5);
  }, []);

  useLayoutEffect(() => {
    updateOverflow();
    const t = requestAnimationFrame(() => updateOverflow());
    return () => cancelAnimationFrame(t);
  }, [text, updateOverflow]);

  useLayoutEffect(() => {
    const el = lineRef.current;
    if (!el || typeof ResizeObserver === 'undefined') return;
    const ro = new ResizeObserver(() => updateOverflow());
    ro.observe(el);
    return () => ro.disconnect();
  }, [text, updateOverflow]);

  const lineClassName =
    'w-full min-w-0 max-w-full cursor-default truncate text-right text-xs font-medium text-slate-800';

  const line = (
    <div ref={lineRef} className={lineClassName}>
      {text}
    </div>
  );

  return (
    <div className="w-60 min-w-0 max-w-60 shrink-0">
      {isOverflowing ? (
        <BaseTooltip
          className="!block w-full min-w-0 max-w-full"
          content={text}
          contentClassName="!max-w-[min(20rem,85vw)] whitespace-normal break-words text-left font-normal"
          position="top"
          delay={200}
        >
          {line}
        </BaseTooltip>
      ) : (
        line
      )}
    </div>
  );
}
